import { render, staticRenderFns } from "./TransformExcel.vue?vue&type=template&id=9cfb076c&scoped=true&"
import script from "./TransformExcel.vue?vue&type=script&lang=js&"
export * from "./TransformExcel.vue?vue&type=script&lang=js&"
import style0 from "./TransformExcel.vue?vue&type=style&index=0&id=9cfb076c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfb076c",
  null
  
)

export default component.exports